module.exports = __webpack_public_path__ + "static/media/proposal_regular_icon.8f3d4344.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/arrivaClick/images/proposal_regular_icon.svg
// module id = 562
// module chunks = 0